import { get as getCookie, set as setCookie } from 'js/lib/cookie';
import { get as getUser, isCourserian } from 'js/lib/user';

import EpicClient from 'bundles/epic/clients/siteMisc';

export const COLOR_THEME_COOKIE = 'colorTheme';

export type ColorSchemePreference = 'light' | 'dark' | 'system';

export const getColorSchemePreference = () => {
  return getCookie(COLOR_THEME_COOKIE);
};

export const setColorSchemePreference = (preference: ColorSchemePreference) => {
  setCookie(COLOR_THEME_COOKIE, preference);
};

export const enableAppearancePreferences = () => {
  const userId = getUser()?.id;
  const enableForCourserians = isCourserian() && EpicClient.get('allowDarkMode');
  const enableForDogfooding = (EpicClient.get('allowDarkModeByUserId') ?? []).includes(userId);
  const enableForUsersWhoAlreadyHaveTheCookie = Boolean(getCookie(COLOR_THEME_COOKIE));
  return enableForCourserians || enableForDogfooding || enableForUsersWhoAlreadyHaveTheCookie;
};

export const getThemeFromUrl = () =>
  typeof window !== 'undefined' ? new URLSearchParams(window.location.search).get('theme') : undefined;

export const getInitialColorTheme = () => {
  const themeFromUrl = getThemeFromUrl();
  return themeFromUrl || getColorSchemePreference() || 'light';
};

/**
 * Detects whether the browser supports dark mode.
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/color_value/light-dark
 * @returns {boolean} true if light-dark() is supported, false otherwise
 */
export const supportsDarkMode = (): boolean => {
  try {
    if (typeof CSS === 'undefined' || !CSS.supports) {
      return false;
    }
    return CSS.supports('color', 'light-dark(red, blue)');
  } catch {
    return false;
  }
};
